import { computed } from 'vue'
// types
import type { ComputedRef } from 'vue'
import type { BlockSectionLayoutProps } from '@ts-blocks/block-section-layout/interfaces'
import type { SectionBannerTextBlockProps } from '@ts-sections/section-banner-text-block/interfaces'

interface SectionBannerTextBlockHookOptions {
  section: () => SectionBannerTextBlockProps
}

interface SectionBannerTextBlockHookReturn {
  refTitle: ComputedRef<string>
  refDescription: ComputedRef<string>
  refBackgroundColor: ComputedRef<NonNullable<BlockSectionLayoutProps['backgroundColor']>>
}

export const useSectionBannerTextBlock = ({ section }: SectionBannerTextBlockHookOptions): SectionBannerTextBlockHookReturn => {
  const refLayout = computed<BlockSectionLayoutProps | null>(() => section().layout ?? null)

  const refTitle = computed<string>(() => refLayout.value?.title ?? '')
  const refDescription = computed<string>(() => refLayout.value?.description ?? '')

  const refBackgroundColor = computed<NonNullable<BlockSectionLayoutProps['backgroundColor']>>(() => (
    refLayout.value?.backgroundColor ?? 'canvas'
  ))

  return {
    refTitle,
    refDescription,
    refBackgroundColor,
  }
}
